/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface PriceSetupModel { 
    id: string;
    creatorId?: string;
    countryId?: string;
    countryName?: string;
    operatorId: number;
    operatorTitle?: string;
    mncCode?: string;
    mccCode?: string;
    routeId: number;
    routeName?: string;
    routeGroupName?: string;
    price: number;
    dateTimeCreated: Date;
    isActive: boolean;
    networkCode?: string;
    isDefault: boolean;
    priceSetupName?: string;
    lowerBound: number;
    upperBound: number;
    smsChannel?: number;
}
